<div class="add-e-document-form">
  <div class="row">
    <div class="col">
      @if (!this.data.dto) {
        <h2>{{ 'AddEDocumentForm.CreateDocument' | translate }}</h2>
      }
      @if (this.data.dto) {
        <h2>{{ 'AddEDocumentForm.EditDocument' | translate }}</h2>
      }
    </div>
  </div>

  <form [formGroup]="formGroup">
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Company' | translate }}</mat-label>
          <mat-select formControlName="companyId">
            @for (company of companies$ | async; track company) {
              <mat-option [value]="company.Id">
                {{ company.Name }}
              </mat-option>
            }
          </mat-select>
          @if (companyIdControl.invalid && companyIdControl.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Pesel' | translate }}</mat-label>
          <input matInput [placeholder]="'Pesel' | translate" autocomplete="family-name" formControlName="pesel" />
          @if (lastNameControl.invalid && lastNameControl.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'FirstName' | translate }}</mat-label>
          <input matInput [placeholder]="'FirstName' | translate" autocomplete="given-name" formControlName="firstName" />
          @if (firstNameControl.invalid && firstNameControl.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'LastName' | translate }}</mat-label>
          <input matInput [placeholder]="'LastName' | translate" autocomplete="family-name" formControlName="lastName" />
          @if (lastNameControl.invalid && lastNameControl.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'DocumentType' | translate }}</mat-label>
          <mat-select formControlName="documentTypeId">
            @for (documentType of documentTypes$ | async; track documentType) {
              <mat-option [value]="documentType.Id">
                {{ documentType.Name }}
              </mat-option>
            }
          </mat-select>
          @if (documentTypeIdControl.invalid && documentTypeIdControl.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'AddEDocumentForm.DocumentPart' | translate }}</mat-label>
          <mat-select formControlName="documentPartId">
            @for (documentPart of documentParts$ | async; track documentPart) {
              <mat-option [value]="documentPart.Id">
                {{ documentPart.Name }}
              </mat-option>
            }
          </mat-select>
          @if (documentPartIdControl.invalid && documentPartIdControl.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <fileUpload
        (onFilesChange)="onFilesChange($event)"
        [ngClass]="{ disabled: data.isReadOnly }"
        [files]="this.originalFileName ? [{ name: this.originalFileName }] : []"
      ></fileUpload>

      <!-- <ng-container">
      <div class="wrapper" *ngIf="files && files?.length > 0">
        <div *ngFor="let file of files">
          <mat-icon>description</mat-icon>
          {{ file.Name }}
          <br />
        </div>
      </div>
    </ng-container> -->
  </div>

  <div class="row">
    <div class="col-md-6">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'AddEDocumentForm.DocumentName' | translate }}</mat-label>
        <input matInput [placeholder]="'AddEDocumentForm.DocumentName' | translate" formControlName="documentName" />
        @if (documentNameControl.invalid && documentNameControl.touched) {
          <mat-error>
            {{ 'InvalidField' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>

    @if (isRequiresExpirationDate$ | async) {
      <div class="col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'AddEDocumentForm.ValidUntilDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="pickValidUntilDate" formControlName="validUntilDate" />
          <mat-datepicker-toggle matSuffix [for]="pickValidUntilDate"></mat-datepicker-toggle>
          <mat-datepicker #pickValidUntilDate></mat-datepicker>
        </mat-form-field>
      </div>
    }
  </div>

  <div class="row">
    <div class="col-md-12">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'AddEDocumentForm.Comments' | translate }}</mat-label>
        <textarea matInput [placeholder]="'Comments' | translate" autocomplete="given-name" formControlName="comments" rows="2"></textarea>
        @if (firstNameControl.invalid && firstNameControl.touched) {
          <mat-error>
            {{ 'InvalidField' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <button mat-raised-button class="mr-1 sign-button" color="accent" (click)="sign()" [ngClass]="{ 'disabled': data.isReadOnly, 'signed': isSigned }" [disabled]="formGroup.invalid || !fileName">
        {{ (isSigned ? 'AddEDocumentForm.Signed' : 'AddEDocumentForm.Sign') | translate }}
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <button mat-raised-button class="mr-1" color="accent" (click)="close()">{{ 'Close' | translate }}</button>
      @if (!data.isReadOnly) {
        <button mat-raised-button class="mr-1 float-right" color="primary" (click)="save()" [disabled]="formGroup.invalid || !fileName">
          {{ 'Save' | translate }}
        </button>
      }
    </div>
  </div>
</form>
</div>
